"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const queryVariablesResolver_1 = __importDefault(require("@aurora/shared-apollo/resolvers/queryVariables/queryVariablesResolver"));
const cachedAssetResolver_1 = __importDefault(require("./asset/cachedAssetResolver"));
const textResolver_1 = __importDefault(require("@aurora/shared-apollo/resolvers/text/textResolver"));
const NamespaceResolverHelper_1 = require("../../helpers/util/NamespaceResolverHelper");
const app_1 = require("@aurora/shared-types/app");
const resolvers = [
    {
        Query: {
            cachedAsset: cachedAssetResolver_1.default,
            cachedText: (0, textResolver_1.default)(app_1.AppType.END_USER, NamespaceResolverHelper_1.aliasResolver, NamespaceResolverHelper_1.defaultNamespaceResolver)
        },
        Mutation: {
            addQueryVariables: queryVariablesResolver_1.default
        }
    }
];
exports.default = resolvers;
//# sourceMappingURL=resolvers.js.map